import { BaseEntity } from "../../core";
import { ClaimMultimedia } from "./claimMultimedia";
import { ClaimStatesEnum } from "./enums/ClaimStatesEnum";

export class Claim extends BaseEntity {
  public claim: number;
  public claimId: number;
  public state: ClaimStatesEnum;
  public stateDescription: string;
  public driver: string;
  public instance: string;
  public place: string;
  public date: Date;
  public dateString: string;
  public hour: string;
  public insuredDomain: string;
  public delayDays: number;
  public insuredLine: string;
  public insuredInternal: number;
  public claimantName: string;
  public claimantVehicle: string;
  public claimantDomain: string;
  public accidentDescription: string;
  public complaint: number;
  public multimedia: ClaimMultimedia[];
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/claim.ts